var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FF0000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "st1",
    d: "M789.02,934.59c-192.48,20.55-385.56,20.55-578.04,0c-76.76-8.19-137.37-68.8-145.57-145.57 c-20.55-192.5-20.55-385.56,0-578.04c8.19-76.76,68.8-137.37,145.57-145.57c192.48-20.55,385.54-20.55,578.04,0 c76.76,8.19,137.37,68.8,145.57,145.57c20.55,192.48,20.55,385.54,0,578.04C926.4,865.78,865.79,926.39,789.02,934.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer-2",
    className: "st0",
    d: "M746.06,376.93c-5.91-21.99-23.24-39.32-45.23-45.25C660.66,320.69,500,320.69,500,320.69 s-160.67,0-200.83,10.56c-21.57,5.92-39.32,23.68-45.25,45.67c-10.56,40.17-10.56,123.45-10.56,123.45s0,83.73,10.56,123.47 c5.92,21.97,23.26,39.32,45.25,45.23c40.59,11,200.83,11,200.83,11s160.67,0,200.83-10.58c21.99-5.91,39.32-23.26,45.25-45.23 c10.56-40.17,10.56-123.47,10.56-123.47s0.42-83.71-10.58-123.87V376.93z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer-3",
    className: "st1",
    d: "M448.85,577.34l133.6-76.96l-133.6-76.94V577.34z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b28458af447e48b15f41d3271775d24d.svg";
export { ForwardRef as ReactComponent };